<ng-template #logoutModalContent let-modal>
	<div class="modal-header align-items-center">
		<span class="modal-title">خروج از حساب</span>
		<button type="button" class="btn-close m-0" aria-label="Close" (click)="onCloseModal(false)">
			<span aria-hidden="true"></span>
		</button>
	</div>
	<div class="modal-body py-4">
		<div>
			<span>آیا مایل به خروج از حساب کاربری خود هستید؟</span>
		</div>
	</div>
	<div class="modal-footer">
		<div class="m-0 d-flex gap-2">
			<button type="button" class="btn btn-outline-secondary" (click)="onCloseModal(false)">انصراف</button>
			<button data-cy="sign-out-confirm" type="button" class="btn btn-danger px-5" (click)="onCloseModal(true)">
				خروج
			</button>
		</div>
	</div>
</ng-template>
